import loc from "owa-localize";
import { appCalendar } from "owa-locstrings/lib/strings/appcalendar.locstring.json";
import { appFiles } from "owa-locstrings/lib/strings/appFiles.locstring.json";
import { appGroups } from "owa-locstrings/lib/strings/appgroups.locstring.json";
import { appPeople } from "owa-locstrings/lib/strings/apppeople.locstring.json";
import { appTasks } from "owa-locstrings/lib/strings/apptasks.locstring.json";
import { appToDo } from "owa-locstrings/lib/strings/apptodo.locstring.json";
import { mailAppName } from "owa-locstrings/lib/strings/mailAppName.locstring.json";
import isWin32StylingEnabled from "owa-theme-win32-style-store/lib/selectors/isWin32StylingEnabled";

/* eslint-disable-next-line owa-custom-rules/forbid-svg-import -- (https://aka.ms/OWALintWiki)
 * BASELINE: DO NOT COPY/PASTE! UNVERIFIED-SVG-DISABLE: confirm no @fluentui/react-icons component exists for this asset and a direct SVG import is truly required. If confirmed, replace this comment with "Direct SVG import required; component-based icon (@fluentui/react-icons) not available for this asset". If an icon replacement is possible, migrate to it and remove the import and this disable
 *	> Referencing SVG files that are available as Fluent v9 icons is forbidden. Use the corresponding Fluent v9 icon instead. Browse available icons in the Fluent UI documentation: https://storybooks.fluentui.dev/react/?path=/docs/fluent-system-icons_icons-catalog--docs */
import word_24x from "owa-appbar-icons/lib/word_24x.svg";
import word_outline from "owa-appbar-icons/lib/word_outline.png";
/* eslint-disable-next-line owa-custom-rules/forbid-svg-import -- (https://aka.ms/OWALintWiki)
 * BASELINE: DO NOT COPY/PASTE! UNVERIFIED-SVG-DISABLE: confirm no @fluentui/react-icons component exists for this asset and a direct SVG import is truly required. If confirmed, replace this comment with "Direct SVG import required; component-based icon (@fluentui/react-icons) not available for this asset". If an icon replacement is possible, migrate to it and remove the import and this disable
 *	> Referencing SVG files that are available as Fluent v9 icons is forbidden. Use the corresponding Fluent v9 icon instead. Browse available icons in the Fluent UI documentation: https://storybooks.fluentui.dev/react/?path=/docs/fluent-system-icons_icons-catalog--docs */
import excel_24x from "owa-appbar-icons/lib/excel_24x.svg";
import excel_outline from "owa-appbar-icons/lib/excel_outline.png";
/* eslint-disable-next-line owa-custom-rules/forbid-svg-import -- (https://aka.ms/OWALintWiki)
 * BASELINE: DO NOT COPY/PASTE! UNVERIFIED-SVG-DISABLE: confirm no @fluentui/react-icons component exists for this asset and a direct SVG import is truly required. If confirmed, replace this comment with "Direct SVG import required; component-based icon (@fluentui/react-icons) not available for this asset". If an icon replacement is possible, migrate to it and remove the import and this disable
 *	> Referencing SVG files that are available as Fluent v9 icons is forbidden. Use the corresponding Fluent v9 icon instead. Browse available icons in the Fluent UI documentation: https://storybooks.fluentui.dev/react/?path=/docs/fluent-system-icons_icons-catalog--docs */
import powerpoint_24x from "owa-appbar-icons/lib/powerpoint_24x.svg";
import powerpoint_outline from "owa-appbar-icons/lib/powerpoint_outline.png";
/* eslint-disable-next-line owa-custom-rules/forbid-svg-import -- (https://aka.ms/OWALintWiki)
 * BASELINE: DO NOT COPY/PASTE! UNVERIFIED-SVG-DISABLE: confirm no @fluentui/react-icons component exists for this asset and a direct SVG import is truly required. If confirmed, replace this comment with "Direct SVG import required; component-based icon (@fluentui/react-icons) not available for this asset". If an icon replacement is possible, migrate to it and remove the import and this disable
 *	> Referencing SVG files that are available as Fluent v9 icons is forbidden. Use the corresponding Fluent v9 icon instead. Browse available icons in the Fluent UI documentation: https://storybooks.fluentui.dev/react/?path=/docs/fluent-system-icons_icons-catalog--docs */
import onenote_24x from "owa-appbar-icons/lib/onenote_24x.svg";
import onenote_outline from "owa-appbar-icons/lib/onenote_outline.png";
import todo_metaos_32 from "owa-appbar-icons/lib/todo_metaos_32.png";
/* eslint-disable-next-line owa-custom-rules/forbid-svg-import -- (https://aka.ms/OWALintWiki)
 * BASELINE: DO NOT COPY/PASTE! UNVERIFIED-SVG-DISABLE: confirm no @fluentui/react-icons component exists for this asset and a direct SVG import is truly required. If confirmed, replace this comment with "Direct SVG import required; component-based icon (@fluentui/react-icons) not available for this asset". If an icon replacement is possible, migrate to it and remove the import and this disable
 *	> Referencing SVG files that are available as Fluent v9 icons is forbidden. Use the corresponding Fluent v9 icon instead. Browse available icons in the Fluent UI documentation: https://storybooks.fluentui.dev/react/?path=/docs/fluent-system-icons_icons-catalog--docs */
import onedrive_24x from "owa-appbar-icons/lib/onedrive_24x.svg";
import onedrive_outline from "owa-appbar-icons/lib/onedrive_outline.png";
/* eslint-disable-next-line owa-custom-rules/forbid-svg-import -- (https://aka.ms/OWALintWiki)
 * BASELINE: DO NOT COPY/PASTE! UNVERIFIED-SVG-DISABLE: confirm no @fluentui/react-icons component exists for this asset and a direct SVG import is truly required. If confirmed, replace this comment with "Direct SVG import required; component-based icon (@fluentui/react-icons) not available for this asset". If an icon replacement is possible, migrate to it and remove the import and this disable
 *	> Referencing SVG files that are available as Fluent v9 icons is forbidden. Use the corresponding Fluent v9 icon instead. Browse available icons in the Fluent UI documentation: https://storybooks.fluentui.dev/react/?path=/docs/fluent-system-icons_icons-catalog--docs */
import Mail_22px from "owa-appbar-icons/lib/Mail_22px.svg";
/* eslint-disable-next-line owa-custom-rules/forbid-svg-import -- (https://aka.ms/OWALintWiki)
 * BASELINE: DO NOT COPY/PASTE! UNVERIFIED-SVG-DISABLE: confirm no @fluentui/react-icons component exists for this asset and a direct SVG import is truly required. If confirmed, replace this comment with "Direct SVG import required; component-based icon (@fluentui/react-icons) not available for this asset". If an icon replacement is possible, migrate to it and remove the import and this disable
 *	> Referencing SVG files that are available as Fluent v9 icons is forbidden. Use the corresponding Fluent v9 icon instead. Browse available icons in the Fluent UI documentation: https://storybooks.fluentui.dev/react/?path=/docs/fluent-system-icons_icons-catalog--docs */
import Calendar_22px from "owa-appbar-icons/lib/Calendar_22px.svg";
/* eslint-disable-next-line owa-custom-rules/forbid-svg-import -- (https://aka.ms/OWALintWiki)
 * BASELINE: DO NOT COPY/PASTE! UNVERIFIED-SVG-DISABLE: confirm no @fluentui/react-icons component exists for this asset and a direct SVG import is truly required. If confirmed, replace this comment with "Direct SVG import required; component-based icon (@fluentui/react-icons) not available for this asset". If an icon replacement is possible, migrate to it and remove the import and this disable
 *	> Referencing SVG files that are available as Fluent v9 icons is forbidden. Use the corresponding Fluent v9 icon instead. Browse available icons in the Fluent UI documentation: https://storybooks.fluentui.dev/react/?path=/docs/fluent-system-icons_icons-catalog--docs */
import People_22px from "owa-appbar-icons/lib/People_22px.svg";
/* eslint-disable-next-line owa-custom-rules/forbid-svg-import -- (https://aka.ms/OWALintWiki)
 * BASELINE: DO NOT COPY/PASTE! UNVERIFIED-SVG-DISABLE: confirm no @fluentui/react-icons component exists for this asset and a direct SVG import is truly required. If confirmed, replace this comment with "Direct SVG import required; component-based icon (@fluentui/react-icons) not available for this asset". If an icon replacement is possible, migrate to it and remove the import and this disable
 *	> Referencing SVG files that are available as Fluent v9 icons is forbidden. Use the corresponding Fluent v9 icon instead. Browse available icons in the Fluent UI documentation: https://storybooks.fluentui.dev/react/?path=/docs/fluent-system-icons_icons-catalog--docs */
import Files_22px from "owa-appbar-icons/lib/Files_22px.svg";
/* eslint-disable-next-line owa-custom-rules/forbid-svg-import -- Direct SVG import required; component-based icon (@fluentui/react-icons) not available for this asset */
import mail_win32 from "owa-appbar-icons/lib/mail_win32.svg";
/* eslint-disable-next-line owa-custom-rules/forbid-svg-import -- Direct SVG import required; component-based icon (@fluentui/react-icons) not available for this asset */
import calendar_win32 from "owa-appbar-icons/lib/calendar_win32.svg";
import { createNativeTitle } from "../createNativeTitle";
import { getAppBposData } from "../../utils/getAppBposData";
import { M365AppId } from "../M365AppId";
import { getCdnUrl } from "owa-config/lib/bootstrapOptions";

import type { StrictTitle } from "../../types";
import type { MailboxInfo } from "owa-client-types";

const getMail = () => {
    const useWin32Icons = isWin32StylingEnabled();
    return createNativeTitle({
        id: M365AppId.Mail,
        nameResolver: () => loc(mailAppName) || "Mail",
        icons: {
            normalIcon: Mail_22px,
            outlineIcon: useWin32Icons
                ? mail_win32
                : `https:${getCdnUrl()}assets/metaos/mail_monoline_20px.svg`,
        },
        platformType: "outlook_app",
    });
};

const getCalendar = () => {
    const useWin32Icons = isWin32StylingEnabled();
    return createNativeTitle({
        id: M365AppId.Calendar,
        nameResolver: () => loc(appCalendar) || "Calendar",
        icons: {
            normalIcon: Calendar_22px,
            outlineIcon: useWin32Icons
                ? calendar_win32
                : `https:${getCdnUrl()}assets/metaos/calendar_monoline_20px.svg`,
        },
        platformType: "outlook_app",
    });
};

const getPeople = () => {
    return createNativeTitle({
        id: M365AppId.People,
        nameResolver: () => loc(appPeople) || "People",
        icons: {
            normalIcon: People_22px,
            outlineIcon: `https:${getCdnUrl()}assets/metaos/people_monoline_20px.svg`,
        },
        platformType: "outlook_app",
    });
};

const getGroups = () => {
    return createNativeTitle({
        id: M365AppId.Groups,
        nameResolver: () => loc(appGroups) || "Groups",
        icons: {
            normalIcon: `https:${getCdnUrl()}assets/groups/icons/v2/GroupsNew.svg`,
            outlineIcon: `https:${getCdnUrl()}assets/groups/icons/v2/GroupsNewOutline.svg`,
        },
        platformType: "outlook_app",
    });
};

const getFiles = () => {
    return createNativeTitle({
        id: M365AppId.Files,
        nameResolver: () => loc(appFiles) || "Files",
        icons: {
            normalIcon: Files_22px,
            outlineIcon: `https:${getCdnUrl()}assets/metaos/files_monoline_20px.svg`,
        },
        platformType: "outlook_app",
    });
};

const getToDo = () => createNativeTitle({
    id: M365AppId.ToDo,
    nameResolver: () => loc(appToDo) || "To Do",
    icons: {
        normalIcon: todo_metaos_32,
        outlineIcon: 
        /* eslint-disable-next-line owa-custom-rules/forbid-hard-coded-cdn-urls -- (https://aka.ms/OWALintWiki)
         * BASELINE. DO NOT COPY AND PASTE!, replace this line with a justification or fix the error
         *	> Hard‑coding CDN URLs is generally discouraged because CDN endpoints vary across environments. Even when working within a single cloud, code should retrieve the current CDN URL dynamically rather than embedding a fixed value.
    For assets uploaded by Outlook Web — request paths beginning with /assets/, /nativehost/, /owamail/ — you can use getCdnUrl() from owa‑config to obtain the correct root CDN URL at runtime.
    To confirm that a resource exists, you can fetch it from the cloud‑specific endpoint. The list of endpoints is documented here:
    https://eng.ms/docs/experiences-devices/global-experiences-platform/outlook/outlook-web/m365-cdn/m365-shared-cdn/docs/onboarding/endpoints  (not all of them are publicly accessible). */
        "https://statics.teams.cdn.office.net/evergreen-assets/apps/0d5c91ee-5be2-4b79-81ed-23e6c4580427_smallImage.png?v=2",
    },
    platformType: "outlook_app",
});

const getTasks = () => createNativeTitle({
    id: M365AppId.Tasks,
    nameResolver: () => loc(appTasks) || "Tasks",
    icons: {
        normalIcon: `https:${getCdnUrl()}assets/metaos/tasks_monoline_20px.svg`,
        outlineIcon: `https:${getCdnUrl()}assets/metaos/tasks_monoline_20px.svg`,
    },
    platformType: "outlook_app",
});

const getWord = (mailboxInfo?: MailboxInfo) => createNativeTitle({
    id: M365AppId.Word,
    nameResolver: () => getAppBposData(M365AppId.Word, mailboxInfo)?.Title ?? "Word",
    icons: {
        normalIcon: word_24x,
        outlineIcon: word_outline,
    },
    platformType: "m365_native_app",
});

const getExcel = (mailboxInfo?: MailboxInfo) => createNativeTitle({
    id: M365AppId.Excel,
    nameResolver: () => getAppBposData(M365AppId.Excel, mailboxInfo)?.Title ?? "Excel",
    icons: {
        normalIcon: excel_24x,
        outlineIcon: excel_outline,
    },
    platformType: "m365_native_app",
});

const getPowerpoint = (mailboxInfo?: MailboxInfo) => createNativeTitle({
    id: M365AppId.PowerPoint,
    nameResolver: () => getAppBposData(M365AppId.PowerPoint, mailboxInfo)?.Title ?? "Powerpoint",
    icons: {
        normalIcon: powerpoint_24x,
        outlineIcon: powerpoint_outline,
    },
    platformType: "m365_native_app",
});

const getOneNote = (mailboxInfo?: MailboxInfo) => createNativeTitle({
    id: M365AppId.OneNote,
    nameResolver: () => getAppBposData(M365AppId.OneNote, mailboxInfo)?.Title ?? "OneNote",
    icons: {
        normalIcon: onenote_24x,
        outlineIcon: onenote_outline,
    },
    platformType: "m365_native_app",
});

const getOneDrive = (mailboxInfo?: MailboxInfo) => createNativeTitle({
    id: M365AppId.OneDrive,
    nameResolver: () => getAppBposData(M365AppId.OneDrive, mailboxInfo)?.Title ?? "OneDrive",
    icons: {
        normalIcon: onedrive_24x,
        outlineIcon: onedrive_outline,
    },
    platformType: "m365_native_app",
});

const getOutlookTitles = () => [
    getCalendar(),
    getFiles(),
    getGroups(),
    getMail(),
    getPeople(),
    getTasks(),
    getToDo(),
];
const getOffice365Titles = (mailboxInfo?: MailboxInfo): StrictTitle[] => [
    getExcel(mailboxInfo),
    getPowerpoint(mailboxInfo),
    getOneNote(mailboxInfo),
    getOneDrive(mailboxInfo),
    getWord(mailboxInfo),
];
const getNativeTitles = (mailboxInfo?: MailboxInfo): StrictTitle[] => [
    ...getOutlookTitles(),
    ...getOffice365Titles(mailboxInfo),
];

export { getNativeTitles };
